import styled from 'styled-components';

export const FormAutoSuggestDropdownStyled = styled.div`
  .box_input_item {
    width: 100%;
  }
`;

export default FormAutoSuggestDropdownStyled;
